import EventEmitter from "base/EventEmitter";
import ValueHelper from "base/ValueHelper";
import Gallery from "webPage/Gallery";
import $ from "jquery";

export default class TouchGallery extends EventEmitter {
    constructor($gallery, options = {}) {
        super();
        this.$gallery = $gallery;
        this.options = $.extend(true, {}, TouchGallery.default_options, options);
        this.touching = false;
        this.animating = false;
        this.prevent_scrolling = false;

        this.touchStart = null;

        this.action = null;

        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);


        this.gallery = new Gallery($gallery, options);

        this.gallery.pipe(this);
        this.limitedCount = this.gallery.getItemCount() <= 2;

        this.bindEvents();
        this.updateClasses();

        TouchGallery.instances.push(this);
    }

    updateClasses() {
        this.gallery.getItems().removeClass(this.options.itemClass + "--next " + this.options.itemClass + "--prev").removeAttr("tabindex");

        if (!this.limitedCount) {
            this.gallery.getItem(this.gallery.getItemIndex(Gallery.FORWARDS)).addClass(this.options.itemClass + "--next").attr("tabindex", "-1");
            this.gallery.getItem(this.gallery.getItemIndex(Gallery.BACKWARDS)).addClass(this.options.itemClass + "--prev").attr("tabindex", "-1");
        }
    }

    onTouchStart(e) {
        if (this.animating) {
            this.touchStart = e.touches;
            e.preventDefault();
            return;
        }

        if (this.touching) {
            this.onTouchEnd(e);
        }

        this.prevent_scrolling = true;

        this.touchStart = e.touches;

        this.touching = true;
        this.action = null;

        TouchGallery.attach_listener(this.$gallery.find("." + this.options.itemsClass), "touchstart", this.onTouchStart);
        TouchGallery.attach_listener($(window), "touchmove", this.onTouchMove);
        TouchGallery.attach_listener($(window), "touchend touchcancel", this.onTouchEnd);

        this.$gallery.find("." + this.options.itemsClass).addClass(this.options.itemsClass + "--dragging");

        this.limitedCount = this.gallery.getItemCount() <= 2;

        this.onTouchMove(e);
    }

    onTouchMove(e) {
        if (!this.touching) {
            return;
        }
        let touch = e.touches[0];
        let dragXOffset = this.dragOffset = touch.clientX - this.touchStart[0].clientX;

        // We haven't yet detected the intended action, it could be zoom or swipe
        if (this.action == null) {
            if (e.touches.length === 2 && this.options.zoom.enabled) {
                this.action = ACTION_ZOOM;
                this.initialDistance = TouchGallery.get_distance(this.touchStart[0], this.touchStart[1]);
                this.focusPoint = {
                    x: (this.touchStart[0].clientX + this.touchStart[1].clientX) / 2,
                    y: (this.touchStart[0].clientY + this.touchStart[1].clientY) / 2,
                };
                this.initialOffset = TouchGallery.get_element_offset(this.gallery.getActiveElement());

                this.initialZoom = TouchGallery.get_element_zoom(this.gallery.getActiveElement());
            } else if (e.touches.length === 1 && this.options.swipe.enabled && this.gallery.getItemCount() >= 2) {

                if (TouchGallery.is_ios()) {
                    // Detect edge swiping and don't attempt to do anything
                    if (this.touchStart[0].clientX <= IOS_EDGE_SWIPE_THRESHOLD || this.touchStart[0].clientX >= $(window).outerWidth() - IOS_EDGE_SWIPE_THRESHOLD) {
                        this.onTouchEnd();
                        return;
                    }
                }

                let totalDistance = TouchGallery.get_distance(touch, this.touchStart[0]);

                let zoom = TouchGallery.get_element_zoom(this.gallery.getActiveElement());
                if (zoom !== 1 && this.options.zoom.enabled) {
                    this.initialZoom = zoom;
                    this.action = ACTION_PAN;

                    this.initialOffset = TouchGallery.get_element_offset(this.gallery.getActiveElement());
                } else if (totalDistance > SWIPE_CHECK_DISTANCE) {
                    let dragYOffset = touch.clientY - this.touchStart[0].clientY;

                    // We've dragged more vertical than horizontal, so we want to scroll
                    if (Math.abs(dragXOffset) < Math.abs(dragYOffset)) {
                        this.onTouchEnd();
                        return;
                    }

                    this.action = ACTION_SWIPE;
                }
            } else {
                // There aren't any actions that we can do at this point. Just scroll as usual
                this.onTouchEnd();
                return;
            }
        }

        if (this.action !== null) {
            e.preventDefault();
        }

        if (this.action === ACTION_SWIPE) {
            this.$gallery.find("." + this.options.itemsClass).css("transform", "translate3d(" + dragXOffset + "px, 0, 0)");

            if (this.limitedCount) {
                let $item = this.gallery.getItem(this.gallery.getItemIndex(Gallery.FORWARDS));
                if (dragXOffset > 0) {
                    $item.removeClass(this.options.itemClass + "--next").addClass(this.options.itemClass + "--prev");
                } else {
                    $item.removeClass(this.options.itemClass + "--prev").addClass(this.options.itemClass + "--next");
                }
            }
        } else if (this.action === ACTION_ZOOM) {
            let currentDistance = TouchGallery.get_distance(e.touches[0], e.touches[1]);
            let scale = currentDistance / this.initialDistance;

            let currentZoom = this.initialZoom * scale;

            let x = this.initialOffset.x;
            let y = this.initialOffset.y;

            //ensure focus point remains between the middle of your fingers
            let currentFocusPoint = {
                x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
                y: (e.touches[0].clientY + e.touches[1].clientY) / 2,
            };

            x += this.focusPoint.x - currentFocusPoint.x;
            y += this.focusPoint.y - currentFocusPoint.y;

            this.emit("zoom", currentZoom);

            this.setImageZoom(currentZoom, x, y);

        } else if (this.action === ACTION_PAN) {
            // Just panning around the current image

            let x = (this.touchStart[0].clientX - e.touches[0].clientX) / this.initialZoom + this.initialOffset.x;
            let y = (this.touchStart[0].clientY - e.touches[0].clientY) / this.initialZoom + this.initialOffset.y;

            this.emit("pan", {
                x: x,
                y: y,
            });

            this.setImageZoom(this.initialZoom, x, y);
        }
    }

    setImageZoom(zoom, x, y) {
        let $element = this.gallery.getActiveElement();
        let $img = $element.find("img");

        // Normalise values
        zoom = ValueHelper.clamp(1, zoom, this.options.zoom.max);

        let maxOffsetX = ($img.outerWidth() - ($element.outerWidth() / zoom)) / 2;
        let maxOffsetY = ($img.outerHeight() - ($element.outerHeight() / zoom)) / 2;

        x = ValueHelper.clamp(-maxOffsetX, x, maxOffsetX);
        y = ValueHelper.clamp(-maxOffsetY, y, maxOffsetY);

        $img.css("transform", "scale(" + zoom + ") translate3d(" + -x + "px, " + -y + "px, 0)");

        $element.data("current-offset", {
            x,
            y,
        }).data("current-zoom", zoom);
    }

    onTouchEnd(e = null) {
        TouchGallery.detach_listener($(window), "touchmove", this.onTouchMove);
        TouchGallery.detach_listener($(window), "touchend touchcancel", this.onTouchEnd);

        this.prevent_scrolling = false;

        if (!this.touching) return;
        this.touching = false;

        let offset = this.dragOffset;

        if (this.action === null) {
            this.resetSwipe(false);
            return;
        }

        if (this.action === ACTION_SWIPE && Math.abs(offset) < MINIMUM_SWIPE_DISTANCE) {
            this.resetSwipe();
            return;
        }
        if (e != null && e.touches.length === 0) e.preventDefault();

        this.$gallery.find("." + this.options.itemsClass).removeClass(this.options.itemsClass + "--dragging").outerWidth();

        if (this.action === ACTION_SWIPE) {
            let galleryWidth = this.$gallery.outerWidth();
            let offsetPercent = offset / galleryWidth;
            if ((e && e.touches.length !== 0) || Math.abs(offsetPercent) < 0.25) {
                this.resetSwipe(false);
            } else {
                this.swipe(offsetPercent > 0 ? Gallery.BACKWARDS : Gallery.FORWARDS);
            }
        } else if (this.action === ACTION_ZOOM) {
            // Noop
        } else {
            // Unknown action
        }

        if (e != null && e.touches.length > 0) {
            // Restart processing the touch events
            this.onTouchStart(e);
        }
    }

    resetSwipe(animate = true) {
        let $wrap = this.$gallery.find("." + this.options.itemsClass);
        if (animate) {
            this.animating = true;
            $wrap.css("transform", "");
            setTimeout(() => {
                this.animating = false;
            }, this.options.animationDuration);
        } else {
            $wrap.addClass(this.options.itemsClass + "--dragging").css("transform", "");
            $wrap.outerWidth();
            $wrap.removeClass(this.options.itemsClass + "--dragging");
            this.animating = false;
        }
    }

    swipe(direction) {
        let newIndex = this.gallery.getItemIndex(direction);

        if (newIndex === this.gallery.getActiveIndex()) {
            this.resetSwipe();
        } else {
            this.gallery.navigate(direction);
        }
    }

    bindEvents() {
        this.$gallery.find("." + this.options.itemsClass).css({
            "touch-action": "pan-y" /* Tell the browser to only handle scrolling*/,
            "user-select": "none" /* Disable selecting text */,
            "-webkit-user-drag": "none" /* Disallow dragging the content */,
            "-webkit-tap-highlight-colour": "rgba(0, 0, 0 ,0)" /* Disable flash of colour on tap */,
            "will-change": "transform",
        });

        this.gallery.on("transitionStart", ({from, to, direction}) => {
            this.setImageZoom(1, 0, 0);

            let parentClass = this.options.itemsClass + "--" + direction;
            this.$gallery.find("." + this.options.itemsClass).addClass(parentClass).css("transform", "");

            this.animating = true;
            let clazz = this.options.itemClass + "--" + (direction === Gallery.FORWARDS ? 'next' : 'prev');

            this.gallery.getItems().each((index, el) => {
                if (index === from || index === to) return;

                $(el).removeClass(this.options.itemClass + "--prev " + this.options.itemClass + "--next");
            });

            this.gallery.getItem(to).addClass(clazz).removeClass(this.options.itemClass + "--" + (direction === Gallery.FORWARDS ? 'prev' : 'next'));

        }).on("transitionEnd", ({direction}) => {
            let clazz = this.options.itemsClass + "--" + direction;

            let $el = this.$gallery.find("." + this.options.itemsClass);

            $el.addClass(this.options.itemsClass + "--dragging").removeClass(clazz);
            // Force reflow
            $el.outerWidth();
            $el.removeClass(this.options.itemsClass + "--dragging");

            this.animating = false;
            this.updateClasses();
        });

        TouchGallery.attach_listener(this.$gallery.find("." + this.options.itemsClass), "touchstart", this.onTouchStart);
    }

    destroy() {
        // Unbind touch handlers
        this.onTouchEnd();
        TouchGallery.detach_listener(this.$gallery.find("." + this.options.itemsClass), "touchstart", this.onTouchStart);

        this.gallery.destroy();
    }

    shouldPreventScrolling() {
        return this.prevent_scrolling;
    }

    static attach_listener($target, events, fn) {
        events.split(" ").forEach((event) => {
            $target.each((_, el) => el.addEventListener(event, fn, {passive: false}));
        });
    }

    static detach_listener($target, events, fn) {
        events.split(" ").forEach((event) => {
            $target.each((_, el) => el.removeEventListener(event, fn));
        });
    }

    static get_distance(touch1, touch2) {
        return Math.sqrt(Math.pow(touch1.clientX - touch2.clientX, 2) + Math.pow(touch1.clientY - touch2.clientY, 2));
    }

    static get_element_zoom($element) {
        let zoom = $element.data("current-zoom");
        return ("number" === typeof zoom ? zoom : 1);
    }

    static get_element_offset($element) {
        let offset = $element.data("current-offset");
        return ("object" === typeof offset ? offset : {
            x: 0,
            y: 0,
        });
    }

    static is_ios() {
        return /Version\/(11|12|13)/.test(navigator.userAgent) || /iPad; CPU OS (11|12|13)/.test(navigator.userAgent) || /iPhone; CPU iPhone OS (11|12|13)/.test(navigator.userAgent);
    }

    static should_prevent_scrolling() {
        let shouldPrevent = false;
        TouchGallery.instances.forEach((instance) => {
            if (shouldPrevent || instance.shouldPreventScrolling()) {
                shouldPrevent = true;
            }
        });
        if (shouldPrevent) {
            return shouldPrevent;
        }

        TouchGallery.scroll_stoppers.forEach((instance) => {
            if (shouldPrevent || instance.shouldPreventScrolling()) {
                shouldPrevent = true;
            }
        });

        return shouldPrevent;
    }
}

export const ACTION_SWIPE = 'swipe';
export const ACTION_ZOOM = 'zoom';
export const ACTION_PAN = 'pan';

export const SWIPE_CHECK_DISTANCE = 30;
export const MINIMUM_SWIPE_DISTANCE = 15;

export const IOS_EDGE_SWIPE_THRESHOLD = 20;

TouchGallery.instances = [];
TouchGallery.scroll_stoppers = [];

TouchGallery.default_options = {
    zoom: {
        enabled: false,
        max: 5,
    },
    swipe: {
        enabled: true,
    },
};

// https://bugs.webkit.org/show_bug.cgi?id=184250 - Safari be stupid
if (TouchGallery.is_ios()) {
    TouchGallery.attach_listener($(window), "touchmove", (e) => {
        if (TouchGallery.should_prevent_scrolling()) {
            e.preventDefault();
        }
    });
}
